export default class UserViewDto {
    constructor(obj) {
        this.login = obj.login
        this.panel = obj.panel
        this.visible = obj.visible
    }
}
